// extracted by mini-css-extract-plugin
module.exports = {"container":"DisplayBoats_container__2zBH-","boat":"DisplayBoats_boat__1Nxt-","position":"DisplayBoats_position__2DZfA","destroy":"DisplayBoats_destroy__3tVhV"};